module.exports = __webpack_public_path__ + "static/media/hero.4c43f0b3.svg";